export default __webpack_public_path__ + "static/media/add_icon.376e9b6a.svg";